import moment from "moment";

// moment-duration-format is a plugin for moment.js required for the format function
import "moment-duration-format";

export const getTimeSince = (
  date,
  t,
  showTime = false,
  showSuffixAgo = false
) => {
  const now = moment(new Date());
  const momentDate = moment(date);
  const diffInHours = now.diff(momentDate, "hours");

  if (diffInHours >= 24) {
    if (showTime) {
      return moment(date).format("DD MMM YYYY, h:mm a");
    }
    const isCurrentYear = momentDate.format("YYYY") === now.format("YYYY");
    return moment(date).format(isCurrentYear ? "D MMM" : "D MMM YYYY");
  } else {
    if (diffInHours < 1) {
      const diffInMin = moment().diff(date, "minutes");
      if (diffInMin < 1) {
        return t("common:now");
      }
      return showSuffixAgo
        ? t("common:minute_abb_ago_with_count", { count: diffInMin })
        : t("common:minit_abb", { minit: diffInMin });
    }
    return showSuffixAgo
      ? t("common:hour_abb_ago_with_count", { count: diffInHours })
      : t("common:hour_abb", { hour: diffInHours });
  }
};

export const getFormattedTimeSince = (date, format, t) => {
  const now = moment();
  const momentDate = moment(date);
  const diffInHours = now.diff(momentDate, "hours");

  if (diffInHours >= 24) {
    return moment(date).format(format);
  } else {
    if (diffInHours < 1) {
      const diffInMin = moment().diff(date, "minutes");
      if (diffInMin < 1) {
        return t("common:now");
      }
      return t("common:minute_abb_ago_with_count", { count: diffInMin });
    }
    return t("common:hour_abb_ago_with_count", { count: diffInHours });
  }
};

export const getDateAndTimeSince = ({ date, format, t }) => {
  if (format) {
    return getFormattedTimeSince(date, format, t);
  } else {
    return getTimeSince(date, t);
  }
};

export const convertDurationToString = duration => {
  const durationString = moment
    .duration(duration, "seconds")
    .format("d[d] h[h] m[m] s[s]", {
      trim: "both final",
    });
  // console.log(duration, durationString);
  return durationString;
};

export const getTimeDifferenceIsNow = ({ nowTime, thenTime }) => {
  const now = moment(nowTime);
  const then = moment(thenTime);
  const diffInMin = now.diff(then, "minutes");
  if (diffInMin < 1) {
    return true;
  }
  return false;
};

export const formatTime = timer => {
  if (!timer) return "00:00";

  const minutes = Math.floor(timer / 60);
  const remainingSeconds = timer - minutes * 60;

  const mm = minutes > 9 ? minutes : `0${minutes}`;
  const ss = remainingSeconds > 9 ? remainingSeconds : `0${remainingSeconds}`;

  return `${mm}:${ss}`;
};

export const getFormattedTimeSinceV2 = (date, t) => {
  const now = moment(new Date());
  const momentDate = moment(date);
  const diffInHours = now.diff(momentDate, "hours");

  if (diffInHours >= 24) {
    const isCurrentYear = momentDate.format("YYYY") === now.format("YYYY");
    return moment(date).format(isCurrentYear ? "D MMM" : "D MMM YYYY");
  } else {
    if (diffInHours < 1) {
      const diffInMin = moment().diff(date, "minutes");
      if (diffInMin < 1) {
        return t("common:now");
      }
      return t("classRoom:minute_abb_ago_with_count", { count: diffInMin });
    }
    return t("classRoom:hour_abb_ago_with_count", { count: diffInHours });
  }
};
